export const MAIN_CLASS_NAME = 'project-source-modal';
export const TITLE_CLASS_NAME = `${MAIN_CLASS_NAME}__title`;
export const RADIO_GROUP_CLASS_NAME = `${MAIN_CLASS_NAME}__radio-group`;
export const RADIO_BUTTON_CLASS_NAME = `${RADIO_GROUP_CLASS_NAME}__button`;
export const RADIO_BUTTON_LABEL_CLASS_NAME = `${RADIO_BUTTON_CLASS_NAME}__label`;

export const CONFLUENCE_DEFAULT_CONTENT_SELECTOR = 'body';
export const CONFLUENCE_DEFAULT_FILTER_SELECTOR = '.recently-updated, .labelsAlphaList';

export const REFRESH_INTERVAL = 3000; // 3 seconds.
export const DEFAULT_MODAL_WIDTH = '75%';
export const SOURCE_TYPE_SELECTION_STEP_MODAL_WIDTH = 424;
export const PARAMETERS_STEP_MODAL_WIDTH = 728;
